// Hero.js
import React from 'react';
import logo from '../assets/logo.jpg';
import './Hero.css'; 

function Hero() {
  return (
    <div className='hero-Page'>
      <header className='hero_header'>
        <img src={logo} alt="logo" />
      </header>
      <div className='hero_center'>
        <p className='developer line'>
          <span className='line1'>I AM</span><br/>
          <span className='line2'>ADARSH</span><br/>
          <span className='line3'>FULL STACK DEVELOPER</span>
        </p>
      </div>
    </div>
  );
}
 
export default Hero;
